import {PropsWithChildren, ReactNode} from "react";
import {FiInfo} from "react-icons/fi";

import {Alert} from "@/components/alert/Alert.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";

interface InstantPopUpProps extends PropsWithChildren {
  show: boolean;
  title: string;
  onCancel: () => void;
  onConfirm: () => void;
  alertCallout: string;
  alertChildren?: ReactNode;
  btnTitle: string;
  loading?: boolean;
}

export const InstantPopUp = ({
  title,
  show,
  onConfirm,
  onCancel,
  btnTitle,
  alertCallout,
  alertChildren,
  children,
  loading,
}: InstantPopUpProps) => {
  return (
    <ActionDialog
      size="lg"
      confirmBtnText={btnTitle}
      onConfirm={onConfirm}
      onCancel={onCancel}
      titleClassName="text-center w-100"
      hasCancelButton={false}
      title={title}
      loading={loading}
      show={show}
    >
      <div className="m-3">
        <div>
          <Alert variant="error" icon={FiInfo} callout={alertCallout}>
            {alertChildren}
          </Alert>
        </div>
        <div className="mt-3">{children}</div>
      </div>
    </ActionDialog>
  );
};
